
import Vue from 'vue'
import { Alert, Loading } from '@/components'
import ProcessingBanner from './components/ProcessingBanner.vue'
import HeaderComponent from './components/Header.vue'
import InputSection from './components/Input/Index.vue'
import ActionButtons from './components/ActionButtons.vue'
import ProductsInCart from './components/ProductsInCart.vue'
import PromoCodes from './components/PromoCodes.vue'
import OrderTotals from './components/OrderTotals.vue'

export default Vue.extend({
   name: 'CheckoutPage',
   computed: {
      loaded() {
         return this.$store.state.modelDataLoaded
      },
      empty() {
         return this.$store.state.modelData.CartItems.length === 0
      },
   },
   methods: {},
   components: {
      ProcessingBanner,
      HeaderComponent,
      InputSection,
      ActionButtons,
      ProductsInCart,
      PromoCodes,
      OrderTotals,
      Alert,
      Loading,
   },
})
